import html2canvas from 'html2canvas'

// A4 page at 96 dpi: 210mm × 297mm → 794 × 1122px
export const PAGE_W_PX = 794
export const PAGE_H_PX = 1122

let _cachedLogoSrc: string | null = null

/**
 * Carrega o logo Loopert, converte SVG → PNG via canvas a 3× (para qualidade nítida
 * mesmo em telas de alta densidade). Resultado cacheado após a primeira chamada.
 */
export async function getLogoDataUrl(): Promise<string> {
    if (_cachedLogoSrc !== null) return _cachedLogoSrc
    try {
        // Dimensões originais do SVG (105×29)
        const LOGO_W = 315  // 3×
        const LOGO_H = 87   // 3×

        const svgUrl = '/assets/images/logo.svg'

        _cachedLogoSrc = await new Promise<string>((resolve) => {
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.onload = () => {
                const canvas = document.createElement('canvas')
                canvas.width = LOGO_W
                canvas.height = LOGO_H
                const ctx = canvas.getContext('2d')!
                ctx.drawImage(img, 0, 0, LOGO_W, LOGO_H)
                resolve(canvas.toDataURL('image/png'))
            }
            img.onerror = () => resolve('')
            img.src = svgUrl
        })
    } catch {
        _cachedLogoSrc = ''
    }
    return _cachedLogoSrc
}

/**
 * Renders an HTML string as an A4-sized PNG (data URL).
 * Temporarily attaches a hidden container to document.body so that
 * html2canvas has a live DOM element to rasterize.
 */
export async function renderHtmlToImage(html: string): Promise<string> {
    const wrapper = document.createElement('div')
    Object.assign(wrapper.style, {
        position: 'absolute',
        left: '-9999px',
        top: '0',
        width: `${PAGE_W_PX}px`,
        height: `${PAGE_H_PX}px`,
        overflow: 'hidden',
    })
    wrapper.innerHTML = html
    document.body.appendChild(wrapper)

    try {
        const canvas = await html2canvas(wrapper, {
            scale: 1.5,
            width: PAGE_W_PX,
            height: PAGE_H_PX,
            useCORS: true,
            allowTaint: true,
            imageTimeout: 0,
            logging: false,
            backgroundColor: '#fafafa',
        })
        return canvas.toDataURL('image/jpeg', 0.85)
    } finally {
        document.body.removeChild(wrapper)
    }
}
